import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller]);

import "./swiperManager"
import SwiperManager from './swiperManager';

$(() => {
  new Swiper('.swiper-voice', {
    slidesPerView: 1.3,
    loop: true,
    spaceBetween: 10,
    speed: 850,
    centeredSlides: true,
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 34,
      },
    },
  })
})
